import { render, staticRenderFns } from "./TagSingle.vue?vue&type=template&id=6f118631"
import script from "./TagSingle.vue?vue&type=script&lang=js"
export * from "./TagSingle.vue?vue&type=script&lang=js"
import style0 from "./TagSingle.vue?vue&type=style&index=0&id=6f118631&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports